import React from "react";
import { useNavigate } from "react-router-dom";
import NavbarWhite from "../components/NavbarWhite";
import Footer from "../components/Footer";
import backgroundImage from "../back2.jpg";
import selezionaIcon from "../seleziona.png";
import okIcon from "../ok.png";
import cartaIcon from "../carta.png";

const Abbonamento = () => {
  const navigate = useNavigate();

  const handlePagaOra = () => {
    navigate("/riepilogo-abbonamento", {
      state: {
        abbonamento: {
          titolo: "Abbonamento Premium – Luglio 2025",
          prezzo: 150,
        },
      },
    });
  };

  return (
    <div
      className="min-h-screen font-[chivo] bg-cover bg-center bg-no-repeat text-black"
      style={{ backgroundImage: `url(${backgroundImage})` }}
    >
      <div className="bg-white/80 min-h-screen">
        <NavbarWhite />
        <div className="pt-32 pb-16 px-6 max-w-5xl mx-auto text-center">
          <h1 className="text-4xl font-bold text-[#009FB7] mb-4">🌞 Abbonamento Premium – 10 Giorni di Mare in Coppia</h1>

          <div className="mb-10 text-center space-y-4">
            <p className="text-2xl font-semibold text-[#009FB7]">
              Goditi il mare tutti i giorni che vuoi 🌴
            </p>
            <p className="text-xl font-medium text-gray-800">
              Solo per il mese di <strong>luglio</strong> – Offerta limitata a <strong>20 abbonamenti</strong>
            </p>
            <p className="text-lg text-gray-700 leading-relaxed max-w-3xl mx-auto">
              Vuoi goderti il mare a luglio senza spendere troppo? Con l’<strong>Abbonamento Premium di luglio</strong>, puoi scegliere 10 giorni da vivere insieme, quando preferisci, dal lunedì al venerdì.
            </p>
            <p className="text-lg text-gray-700 leading-relaxed max-w-3xl mx-auto">
              Un posto riservato ogni volta, nessuna folla, tanta tranquillità. E soprattutto… un prezzo speciale!
            </p>
          </div>

          <div className="relative p-10 bg-white rounded-3xl border border-[#009FB7]/30 shadow-xl hover:shadow-2xl hover:scale-[1.01] transition-transform duration-300 ease-in-out mb-12 max-w-3xl mx-auto">
            <h2 className="text-3xl font-bold text-[#009FB7] mb-6 flex items-center gap-2 justify-center">
              <span className="text-2xl">✅</span> Cosa include
            </h2>

            <div className="space-y-3 text-left text-gray-800 mb-6">
              <div className="flex items-start gap-3">
                <span className="text-[#009FB7] mt-1">📅</span>
                <p>10 ingressi totali (nei giorni che preferisci)</p>
              </div>
              <div className="flex items-start gap-3">
                <span className="text-[#009FB7] mt-1">📆</span>
                <p>Dal lunedì al venerdì, durante luglio 2025</p>
              </div>
              <div className="flex items-start gap-3">
                <span className="text-[#009FB7] mt-1">🏖️</span>
                <p>1 ombrellone + 2 lettini garantiti ogni giorno</p>
              </div>
              <div className="flex items-start gap-3">
                <span className="text-[#009FB7] mt-1">👫</span>
                <p>Nominale per due persone</p>
              </div>
            </div>

<div className="bg-[#e0f7fa] p-4 rounded-xl text-center mb-6">
  <p className="text-lg font-medium text-[#007a91]">💰 Risparmia fino al 50%</p>
  <p className="text-lg text-black mt-1">
    Se acquistassi ogni giorno singolarmente, spenderesti fino a <strong>€300</strong>.<br />
    Con l’abbonamento paghi solo <strong>€150</strong> → Risparmi esattamente <span className="text-green-600 font-semibold">€150</span>!
  </p>
</div>


            <div className="text-center">
              <button
                onClick={handlePagaOra}
                className="bg-[#009FB7] hover:bg-[#007a91] text-white px-8 py-3 rounded-full font-semibold text-lg shadow-md transition"
              >
                Acquista Abbonamento
              </button>
            </div>
          </div>

          <div className="grid gap-5 text-left text-base sm:text-lg text-gray-800 mb-14 leading-relaxed">
            <h3 className="text-lg font-semibold text-[#009FB7] text-center">📞 Come funziona?</h3>
            {[
              { icon: selezionaIcon, text: "Acquista online sul sito oppure scrivi direttamente su WhatsApp" },
              { icon: okIcon, text: "Ricevi conferma dell’acquisto" },
              { icon: okIcon, text: "Vieni al lido nei giorni che preferisci (lun–ven)" },
              { icon: okIcon, text: "Il tuo posto è sempre garantito: 1 ombrellone + 2 lettini" },
            ].map((item, index) => (
              <div key={index} className="flex items-center bg-[#fff5d7] border border-[#FFD700] rounded-lg px-4 py-3 shadow">
                <img src={item.icon} alt="" className="w-6 h-6 mr-3" />
                <p>{item.text}</p>
              </div>
            ))}

            <h3 className="text-lg font-semibold text-[#009FB7] text-center mt-6">🚫 Condizioni importanti</h3>
            {[
              "L’abbonamento è valido solo per il mese di luglio 2025",
              "È nominale per due persone",
              "Non è modificabile né rimborsabile",
              "Non cumulabile con altre offerte",
              "Solo 20 posti disponibili",
              "Acquistabile una sola volta per utente",
            ].map((text, index) => (
              <div key={index} className="flex items-center bg-[#fff5d7] border border-[#FFD700] rounded-lg px-4 py-3 shadow">
                <img src={okIcon} alt="" className="w-6 h-6 mr-3" />
                <p>{text}</p>
              </div>
            ))}

            <h3 className="text-lg font-semibold text-[#009FB7] text-center mt-6">❓ Domande Frequenti (FAQ)</h3>
            {[
              ["Posso cambiare i giorni dopo aver acquistato?", "No, l’abbonamento è “usa quando vuoi” entro luglio, ma non si può estendere fuori stagione."],
              ["Posso regalare l’abbonamento a qualcun altro?", "Sì, ma rimane nominale: i nomi indicati all’acquisto saranno gli unici validi per l’accesso."],
              ["Posso acquistare più di un abbonamento?", "No, l’abbonamento è acquistabile una sola volta per persona, per garantire equità."],
              ["Posso utilizzarlo anche nel weekend?", "No, questa promozione è valida solo dal lunedì al venerdì."],
            ].map(([q, a], index) => (
              <div key={index} className="bg-[#fff5d7] border border-[#FFD700] rounded-lg px-4 py-3 shadow">
                <p><strong>{q}</strong><br />{a}</p>
              </div>
            ))}

            <h3 className="text-lg font-semibold text-[#009FB7] text-center mt-6">🗓️ Perché acquistare ora?</h3>
            {[
              "✨ Prenota il tuo posto fisso prima che finiscano",
              "🧘‍♀️ Goditi il mare in tranquillità durante la settimana",
              "🎉 Usa i tuoi 10 giorni come preferisci, lun–ven",
              "💬 Solo 20 abbonamenti disponibili",
            ].map((text, index) => (
              <div key={index} className="flex items-center bg-[#fff5d7] border border-[#FFD700] rounded-lg px-4 py-3 shadow">
                <img src={okIcon} alt="" className="w-6 h-6 mr-3" />
                <p>{text}</p>
              </div>
            ))}
          </div>

          <p className="text-sm text-gray-500 text-center">Il pagamento avviene tramite circuito sicuro sul sito ufficiale.</p>
          <div className="text-center mt-6">
            <button
              onClick={handlePagaOra}
              className="bg-[#009FB7] hover:bg-[#007a91] text-white px-8 py-3 rounded-full font-semibold text-lg shadow-md transition"
            >
              Acquista Abbonamento
            </button>
          </div>
        </div>
        <Footer />
      </div>
    </div>
  );
};

export default Abbonamento;
